import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import IntroSection from '../components/IntroSection';
import ChallengesSection from '../components/ChallengesSection';
import PageSEO from '../components/PageSEO';
import FrameworkSection from '../components/FrameworkSection';
import ApproachSection from '../components/ApproachSection';
import RightPathSection from '../components/RightPathSection';
import ConsultingSection from '../components/ConsultingSection';
import ServicesShowcase from '../components/ServicesShowcase';
import AboutSection from '../components/AboutSection';
import TrustedBy from '../components/TrustedBy';
import FooterCTA from '../components/FooterCTA';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="homepage">
      <PageSEO
        path="/"
        description="Enterprise-level talent solutions for small businesses, franchises, civic organizations, and nonprofits. The Right 6 Framework delivers Fortune 1000 workforce expertise to growing organizations in Denver, CO."
      />
      <Header />
      <HeroSection />
      <IntroSection />
      <ChallengesSection />
      <FrameworkSection />
      <ApproachSection />
      <ServicesShowcase />
      <AboutSection />
      <TrustedBy />
      <FooterCTA />
      <Footer />
    </div>
  );
};

export default HomePage;